import PosthogService from '~/services/posthog/PosthogService';

export interface IEditShiftAutoconfirmEligibleSelectedPayload {
  autoConfirm: 'on' | 'off';
  designDate: number;
}

/**
 * Fires when a user turns autoconfirm eligible professionals ON/OFF on the edit shift page
 * Event: dental_portal:edit_shift:autoconfirm_eligible_selected
 */
export function fireEditShiftAutoconfirmEligibleSelected(
  payload: IEditShiftAutoconfirmEligibleSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:edit_shift:autoconfirm_eligible_selected',
    {
      'auto-confirm': payload.autoConfirm,
      design_date: payload.designDate,
    },
  );
}
